<template>
  <layout-main-inner :title="$route.query.deliveryAddressId ? '编辑收货地址' : '新增收货地址'">
    <el-form :model="delivery"
             :rules="rules"
             ref="ruleForm"
             label-position='top'>
      <layout-card-wrap hasHeaderSlot
                        v-loading="loading">
        <template slot="title">基本信息</template>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收货人:"
                          prop="deliveryName">
              <el-input v-model="delivery.deliveryName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话:"
                          prop="deliveryPhone">
              <el-input v-model="delivery.deliveryPhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收件省市(地区)区(县):"
                          prop="area">
              <area-select v-model="delivery.area" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="详细地址:"
                          prop="detailedAddress">
              <el-input v-model="delivery.detailedAddress"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="销售区域(H5展示):"
                          prop="saleAreaName">
              <el-input v-model="delivery.saleAreaName"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="销售区域:"
              prop="saleAreas">
              <checkbox-tree ref="area"
                :treeData="cityTree"
                nodeKey="areaCode"
                :expandAll="false"
                :defaultProps="defaultProps"
                v-model="delivery.saleAreas" />
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item label="销售区域:"
                          prop="saleAreas">
              <el-cascader-panel class="custom-cascader-panel"
                                 :options="cityTree"
                                 v-model="delivery.saleAreas"
                                 :props="props"></el-cascader-panel>
            </el-form-item>
          </el-col>
        </el-row>

      </layout-card-wrap>
    </el-form>
    <template slot="footer">
      <back-button ref="back" />
      <el-button type="primary"
                 @click="update"
                 v-if="$route.query.deliveryAddressId"
                 :loading="loading">保存</el-button>
      <el-button type="primary"
                 @click="create"
                 v-else
                 :loading="loading">保存</el-button>
    </template>
  </layout-main-inner>
</template>

<script>
import AreaSelect from './busi/area-select.vue'
// import CheckboxTree from '@/components/public/checkbox-tree.vue'
import { mapState } from 'vuex'
// import _ from 'lodash'
export default {
  name: 'delivery-edit',
  components: { AreaSelect }, // CheckboxTree
  props: {},
  data () {
    return {
      loading: false,
      defaultProps: {
        children: 'children',
        label: 'areaName'
      },
      props: {
        multiple: true,
        value: 'areaCode',
        children: 'children',
        label: 'areaName'
      },
      rules: {
        deliveryName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { max: 30, message: '长度最大 30 个字符', trigger: 'blur' }
        ],
        deliveryPhone: [
          { required: true, message: '请输入手机/座机号码', trigger: 'blur' }// pattern: /^1[0-9][0-9]\d{8}$/,
        ],
        area: [
          { required: true, message: '请选择省市(地区)区(县)', trigger: 'blur' }
        ],
        detailedAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        saleAreaName: [
          { required: false, message: '请输入销售区域', trigger: 'blur' }
        ],
        saleAreas: [
          { required: true, message: '请选择销售区域', trigger: 'blur' }
        ]
      },
      delivery: {
        area: [],
        saleAreas: []
      },
      cityTree: []
    }
  },
  computed: {
    ...mapState({
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    create () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          // let saleAreas = _.cloneDeep(this.$refs.area.getCheckedNodes())
          // let province = []
          // saleAreas.forEach(item => {
          //   if (item.level === 1) {
          //     province.push(item.provinceCode)
          //   }
          // })
          // _.remove(saleAreas, item => item.level === 2 && province.indexOf(item.provinceCode) > -1)
          // console.log(saleAreas)
          let { deliveryName, deliveryPhone, detailedAddress, saleAreaName, area, saleAreas } = this.delivery
          this.$store.dispatch('delivery/adddeliveryaddress', {
            payload: {
              // vendorId: this.$route.query.vendorId,
              ...this.$route.query,
              deliveryName,
              deliveryPhone,
              detailedAddress,
              saleAreaName,
              provinceCode: area[0],
              cityCode: area[1],
              areaCode: area[2],
              saleAreas: saleAreas.map(item => ({ provinceCode: item[0], cityCode: item[1], areaCode: item[2] }))
            },
            success: (res) => {
              this.loading = false
              this.$refs.back.back()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    update () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          // let saleAreas = _.cloneDeep(this.$refs.area.getCheckedNodes())
          // let province = []
          // saleAreas.forEach(item => {
          //   if (item.level === 1) {
          //     province.push(item.provinceCode)
          //   }
          // })
          // _.remove(saleAreas, item => item.level === 2 && province.indexOf(item.provinceCode) > -1)
          // console.log(saleAreas)
          let { deliveryName, deliveryPhone, detailedAddress, saleAreaName, area, saleAreas } = this.delivery
          this.$store.dispatch('delivery/updatedeliveryaddress', {
            payload: {
              // vendorId: this.$route.query.vendorId,
              ...this.$route.query,
              deliveryAddressId: this.$route.query.deliveryAddressId,
              deliveryName,
              deliveryPhone,
              detailedAddress,
              saleAreaName,
              provinceCode: area[0],
              cityCode: area[1],
              areaCode: area[2],
              saleAreas: saleAreas.map(item => ({ provinceCode: item[0], cityCode: item[1], areaCode: item[2] }))
            },
            success: (res) => {
              this.loading = false
              this.$refs.back.back()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getdeliveryaddress () {
      this.loading = true
      this.$store.dispatch('delivery/getdeliveryaddress', {
        payload: {
          vendorId: this.$route.query.vendorId,
          deliveryAddressId: this.$route.query.deliveryAddressId
        },
        success: (res) => {
          const saleAreas = this.userDetail.saleAreaLevel === 3 ? res.data.saleAreas.map(item => [item.provinceCode, item.cityCode, item.areaCode]) : res.data.saleAreas.map(item => [item.provinceCode, item.cityCode])
          this.delivery = {
            ...this.delivery,
            ...res.data,
            area: [res.data.provinceCode, res.data.cityCode, res.data.areaCode],
            saleAreas: saleAreas
          }
          this.loading = false
          // this.getcitytree()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    // getcitytree () {
    //   this.loading = true
    //   this.$store.dispatch('delivery/getcitytree', {
    //     payload: {},
    //     success: (res) => {
    //       res.data.areaNodes.forEach(i => {
    //         i.provinceCode = i.areaCode
    //         i.children.forEach(s => {
    //           s.provinceCode = i.areaCode
    //           s.cityCode = s.areaCode
    //         })
    //       })
    //       this.cityTree = res.data.areaNodes
    //       this.loading = false
    //     },
    //     fail: () => {
    //       this.loading = false
    //     }
    //   })
    // },
    getareatree () {
      this.loading = true
      this.$store.dispatch('delivery/getareatree', {
        payload: {},
        success: (res) => {
          res.data.areaNodes.forEach(i => {
            i.provinceCode = i.areaCode
            i.children.forEach(s => {
              s.provinceCode = i.areaCode
              s.cityCode = s.areaCode
              if (this.userDetail.saleAreaLevel === 3) {
                s.children = s.children || []
                s.children.forEach(m => {
                  m.provinceCode = i.areaCode
                  m.cityCode = s.areaCode
                  m.district = m.areaCode
                })
              } else {
                s.children = null
              }
            })
          })
          this.cityTree = res.data.areaNodes
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  },
  mounted () {
    if (this.$route.query.deliveryAddressId) {
      this.getdeliveryaddress()
    } else {
      // this.getcitytree()
    }
    this.getareatree()
  }
}
</script>
<style lang="stylus">
.custom-cascader-panel {
  .el-cascader-menu__wrap {
    height: 500px !important;
  }
}
</style>
